export default "__VITE_ASSET__013afca0__"